<template>
  <div style="margin: 16px;">
    <el-col v-loading="inventory == null">
      <el-row v-if="inventory != null" :gutter="16">
        <el-col :xs="24" :sm="14">
          <el-card
            :v-loading="issuedL == null"
            shadow="hover"
            class="box-card"
            body-style="padding: 16px; padding-top: 8px;"
          >
            <div slot="header" class="clearfix">
              <span>Inventory</span>
              <el-popover placement="top" width="300" v-model="reqVisible" trigger="click">
                <el-select
                  v-model="reqL.item_id"
                  style="width: 100%"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="remoteMethod"
                  :loading="reqLoading"
                  placeholder="Search..."
                >
                  <el-option
                    v-for="item in searchList"
                    :key="item.o_id"
                    :label="item.item_name"
                    :value="item.o_id"
                  ></el-option>
                </el-select>
                <el-input-number
                  size="small"
                  style="width: 100%; margin-top: 8px;"
                  :min="1"
                  :max="10"
                  v-model="reqL.amount"
                ></el-input-number>

                <hr style="margin: 16px; margin-top: 8px;" />

                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="reqVisible = false">Cancel</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    :disabled="reqL.item_id == null"
                    @click="requestInventory"
                  >Submit</el-button>
                </div>

                <el-button slot="reference" style="float: right; padding: 3px 0" type="text">Request</el-button>
              </el-popover>
            </div>
            <span v-if="issuedL == null || issuedL.length == 0" class="center-message">No Inventory</span>
            <div v-else>
              <el-table
                v-if="inventory != null && inventoryTypes != null"
                @row-click="openDialog"
                :data="issuedL"
              >
                <el-table-column
                  label="Item"
                  :fixed="$mq === 'xs' ? false : 'left'"
                  sortable
                  prop="item_id"
                  min-width="150"
                >
                  <template
                    slot-scope="scope"
                  >{{ inventory.find(log => log.o_id == scope.row.item_id).item_name }}</template>
                </el-table-column>
                <el-table-column
                  label="Amount"
                  sortable
                  prop="amount"
                  align="center"
                  min-width="100"
                ></el-table-column>
                <el-table-column align="center" prop="item_id" label="Type" width="100">
                  <template slot-scope="scope">
                    <span>{{inventoryTypes.find(t => t.o_id == inventory.find(log => log.o_id == scope.row.item_id).inventory_type_id).name}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="10">
          <el-card
            :v-loading="pendingI == null"
            shadow="hover"
            class="box-card"
            body-style="padding: 16px; padding-top: 8px;"
          >
            <div slot="header" class="clearfix">
              <span>Pending</span>
            </div>
            <span
              v-if="pendingI == null || pendingI.length == 0 || inventoryTypes == null"
              class="center-message"
            >No Pending Inventory</span>
            <div v-else>
              <div class="list-tile" v-for="l in pendingI" :key="l.o_id">
                <div style="display: flex;">
                  <span
                    class="list-title"
                    style="margin-right: auto"
                  >{{inventory.find(log => log.o_id == l.item_id).item_name}}</span>
                  <el-tag
                    style="margin-top: 8px; margin-left: 8px;"
                    size="small"
                    :type="l.is_approved ? 'success' : 'warning'"
                  >{{l.is_approved ? 'Pending Issue' : 'Pending Approval'}}</el-tag>
                </div>
                <div style="display: flex">
                  <span
                    class="list-subtext"
                    style="margin-right: auto;"
                  >{{inventoryTypes.find(t => t.o_id == inventory.find(log => log.o_id == l.item_id).inventory_type_id).name}}</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-col>
    <el-dialog title="Return Item" 
      :visible.sync="dialogVisible" 
      :fullscreen="$mq === 'xs'"
      @close="clearReq" width="450px">
      <p
        v-if="reqI.item_id"
      >How many {{ inventory.find(log => log.o_id == reqI.item_id).item_name }} would you like to return?</p>
      <el-form>
        <el-form-item label="Amount">
          <el-input-number size="medium" :min="0" :max="reqI.amount" v-model="reqI.ret_amount"></el-input-number>
        </el-form-item>
      </el-form>

      <hr />

      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="closeDialog">Cancel</el-button>
        <el-button type="danger" size="mini" @click="returnInventory(reqI)">Return</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    props: ["selected_update"],
    mounted() {
        this.pullInventory();
        if (this.inventory == null) this.$store.dispatch("pullInventory");
    },
    computed: {...mapFields(["user", "inventory", "inventoryTypes"])},
    data() {
        return {
            dialogVisible: false,
            reqVisible: false,
            reqLoading: false,
            searchList: [],
            reqL: {
                amount: 0,
                item_id: null
            },

            reqI: {
                amount: 0,
                item_id: null,
                ret_amount: 0
            },
            issuedL: null,
            pendingI: null
        };
    },
    methods: {
        openDialog(row) {
            this.reqI = JSON.parse(JSON.stringify(row));
            this.$set(this.reqI, "ret_amount", this.reqI.amount);
            this.dialogVisible = true;
        },
        closeDialog() {
            this.dialogVisible = false;
            this.clearReq();
        },
        clearReq() {
            this.reqI = {
                o_id: null,
                ret_amount: 0,
                amount: 0
            };
        },
        returnInventory(lItem) {
            this.axios
                .post(
                    "/api/v1/inventory/return",
                    {
                        amount: lItem.ret_amount,
                        record_id: lItem.o_id
                    },
                    {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    }
                )
                .then((response) => {
                    var index = this.issuedL.findIndex((objv) => objv.o_id == lItem.o_id);
                    if (lItem.amount == response.data.amount) {
                        this.issuedL.splice(index, 1);
                    } else {
                        this.issuedL.splice(index, 1, response.data);
                    }
                    this.closeDialog();
                    this.$message({
                        showClose: true,
                        message: "Inventory return sent",
                        type: "success"
                    });
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
            lItem.delVisible = false;
        },
        remoteMethod(query) {
            if (query !== "") {
                this.reqLoading = true;
                setTimeout(() => {
                    this.reqLoading = false;
                    this.searchList = this.inventory.filter((item) => {
                        return (
                            item.item_name.toLowerCase().indexOf(query.toLowerCase()) > -1
                        );
                    });
                }, 200);
            } else {
                this.searchList = this.inventory;
            }
        },
        requestInventory() {
            this.axios
                .post(
                    "/api/v1/inventory/request",
                    {
                        amount: this.reqL.amount,
                        item_id: this.reqL.item_id
                    },
                    {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    }
                )
                .then((response) => {
                    this.pendingI.push(response.data);
                    this.$message({
                        showClose: true,
                        message: "Inventory request submitted",
                        type: "success"
                    });
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
            this.reqVisible = false;
            this.reqL.amount = 1;
            this.reqL.item_id = null;
        },
        pullInventory() {
            this.axios
                .get("/api/v1/inventory/pending", {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.pendingI = response.data.filter((l) => l.is_issued == 0);
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
            this.axios
                .get("/api/v1/inventory/issued", {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    if (!Array.isArray(response.data)) {
                        this.issuedL = Object.values(response.data);
                    } else {
                        this.issuedL = response.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        }
    }
};
</script>
